export default {
  'pages.home': 'الرئيسية',
  'pages.about': 'حول',
  'pages.login_form': 'نموذج تسجيل الدخول',
  'pages.signup_success': 'نجاح الاشتراك',
  'pages.create_business_profile': 'إنشاء ملف تعريف للعمل',
  'pages.complete_profile': 'اكمال الملف الشخصي',
  'pages.send_password_successfully': 'إرسال كلمة المرور بنجاح',
  'pages.forget_password': 'نسيت كلمة المرور',
  'pages.ticket_mangment': 'إدارة التذاكر',
};
